import {
  http
} from '../config';
import base from './base';

export const announcement={
  getAnnouncementList(data){
    return http({
      url:`${base.users}/teacherProxy/queryAnnouncementList`,
      method:'post',
      data
    });
  },
  getAnnouncementDetail(resId){
    return http({
      url:`${base.users}/teacherProxy/queryAnnouncementDetails/${resId}`,
      method:'get',
    });
  },
  deleteAnnouncement(resId){
    return http({
      url:`${base.users}/teacherProxy/deleteAnnouncementDetails/${resId}`,
      method:'delete',
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/announcement.js